import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const UnstyledSMID = dynamic(() => import('./unstyled-smid'));

Builder.registerComponent(UnstyledSMID, {
  name: 'UnstyledSMID',
  noWrap: true,
  friendlyName: 'Unstyled SMID',
});
